import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {FormsGlobals} from '../../../../models/forms/forms.enum';
import {FormsBuilderPolishedService} from '../services/forms-builder-polished.service';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {EnumValidValueModel} from '../../../../models/enum/enum-valid-value.model';
import {FormItemConfigurationModel} from '../../../../models/forms/form-item-configuration.model';
import {FormConfigurationModel} from '../../../../models/forms/form-configuration.model';
import {FormItemActionConfigurationModel} from '../../../../models/forms/form-item-action-configuration.model';
import {FormsConstants} from '../../models/forms-constants';

@Component({
  selector: 'app-forms-builder-polished-item',
  templateUrl: './forms-builder-polished-item.component.html',
  styleUrls: ['./forms-builder-polished-item.component.css']
})
export class FormsBuilderPolishedItemComponent implements OnInit {

  item: FormItemConfigurationModel;
  originalItem: FormConfigurationModel;

  isLoading: boolean = false;
  canUseValidValues: boolean = true;
  canUseDefaultValue: boolean = true;
  canUseAfterUpdateAction: boolean = true;
  canSelectDefaultFromValidValue: boolean = true;

  cfgItemAlignmentTypeList: any[] = [];
  cfgFormItemTypeList: any[] = [];
  otherItemsInForm: FormItemConfigurationModel[] = [];
  validValues: EnumValidValueModel[] = [];
  actionList: FormItemActionConfigurationModel[] = [];

  selectedBeforeActionId: string;
  selectedAfterActionId: string;
  selectedParentItemId: string;
  selectedAlignmentType: string;
  selectedValidValue: EnumValidValueModel;
  selectedControlTypeId: string;
  selectedValidValueId: string;

  constructor(
    private globals: FormsGlobals,
    private formsBuilderService: FormsBuilderPolishedService,
    public dialogRef: MatDialogRef<FormsBuilderPolishedItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.setupAllFields();
    this.originalItem = this.data.cfgItem;
    this.validValues = this.data.validValues;
    this.actionList = this.data.actionList;
    this.otherItemsInForm = this.data.otherItems.sort((a: FormItemConfigurationModel, b: FormItemConfigurationModel) => {
      if (a.DFormItemName.toLowerCase() < b.DFormItemName.toLowerCase()) { return -1; }
      if (a.DFormItemName.toLowerCase() > b.DFormItemName.toLowerCase()) { return 1; }
      return 0;
    });
    this.item = JSON.parse(JSON.stringify(this.data.cfgItem));
    this.selectedControlTypeId = this.item.enumFormControlID;
    this.selectedValidValueId = this.item.ValidValueId;
    this.selectedValidValue = this.item.ValidValue;
    this.selectedParentItemId = this.item.ParentDFormItemId;
    this.selectedAlignmentType = this.item.enumLabelAligmentID;
    this.selectedAfterActionId = this.item.AfterUpdate_ItemActionId;
    this.selectedBeforeActionId = this.item.BeforeDisplay_ItemActionId;
    this.checkOptions();
  }

  selectDefaultValue(validValueItem: EnumValidValueItemModel) {
    this.item.DefaultValue = validValueItem.ValidValueItemId;
  }

  setupAllFields() {
    this.setupItemTypeList();
    this.setupAlignmentList();
  }

  selectControlType(controlType) {
    this.selectedControlTypeId = controlType.id;
    this.item.enumFormControl = null;
    this.item.enumFormControlID = this.selectedControlTypeId;
    this.checkOptions();
  }

  removeDefaultValue() {
    this.item.DefaultValue = null;
  }

  selectParentItem(parentItem: FormItemConfigurationModel) {
    this.selectedParentItemId = parentItem.DFormItemId;
    this.item.ParentDFormItemId = parentItem.DFormItemId;
  }

  selectValidValue(validValue: EnumValidValueModel) {
    this.selectedValidValueId = validValue.ValidValueId;
    this.selectedValidValue = validValue;
    this.item.ValidValue = null;
    this.item.ValidValueId = this.selectedValidValueId;
    this.checkOptions();
  }

  selectBeforeAction(action: FormItemActionConfigurationModel) {
    this.selectedBeforeActionId = action.ItemActionId;
    this.item.BeforeDisplayItemAction = null;
    this.item.BeforeDisplay_ItemActionId = this.selectedBeforeActionId;
  }

  selectAfterAction(action: FormItemActionConfigurationModel) {
    this.selectedAfterActionId = action.ItemActionId;
    this.item.AfterUpdateItemAction = null;
    this.item.AfterUpdate_ItemActionId = this.selectedAfterActionId;
  }

  removeBeforeAction() {
    this.item.BeforeDisplayItemAction = null;
    this.item.BeforeDisplay_ItemActionId = null;
    this.selectedBeforeActionId = null;
  }

  removeAfterAction() {
    this.item.AfterUpdateItemAction = null;
    this.item.AfterUpdate_ItemActionId = null;
    this.selectedAfterActionId = null;
  }

  clearParentItem() {
    this.item.ParentDFormItemId = null;
    this.selectedParentItemId = null;
  }

  setupAlignmentList() {
    this.cfgItemAlignmentTypeList = [
      { name: 'Left', id: '00000036-1000-0000-0000-000000000001' },
      { name: 'Right', id: '00000036-1000-0000-0000-000000000002' },
      { name: 'Center', id: '00000036-1000-0000-0000-000000000003' },
    ];
  }

  selectAlignmentType(alignmentType) {
    this.item.enumLabelAligmentID = alignmentType.id;
    this.item.enumLabelAligment = null;
  }

  returnItemTypeIcon(item: FormItemConfigurationModel) {
    return this.cfgFormItemTypeList.find(itemType => {
      return itemType.id == item.enumFormControlID;
    }).icon;
  }

  setupItemTypeList() {
    this.cfgFormItemTypeList = FormsConstants.cfgFormItemTypeList;
    this.cfgFormItemTypeList = this.cfgFormItemTypeList.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
      if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
      return 0;
    });
  }

  fetchAllActions() {
    const promise = new Promise((resolve, reject) => {
      this.formsBuilderService.getAllActions()
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  fetchAllValidValues() {
    const promise = new Promise((resolve, reject) => {
      this.formsBuilderService.getAllValidValues()
        .subscribe(response => {
          resolve(response);
        }, err => {
          reject(err);
        });
    });
    return promise;
  }

  getValidValuePreview(validValue: EnumValidValueModel) {
    return validValue.enumValidValueItems.map(vv => vv.ItemDisplayValue).join(', ');
  }

  checkOptions() {
    const canValidValueControlTypes = [
      this.globals.CONTROL_ACTION_BUTTON,
      this.globals.CONTROL_BLOOD_PRESSURE,
      this.globals.CONTROL_CURRENCY,
      this.globals.CONTROL_DATE,
      this.globals.CONTROL_DATE_TIME,
      this.globals.CONTROL_GROUP_HEADING_WITH_SUMMARY,
      this.globals.CONTROL_HEADING,
      this.globals.CONTROL_LABEL,
      this.globals.CONTROL_LABEL_45,
      this.globals.CONTROL_NUMERIC_DECIMAL,
      this.globals.CONTROL_NUMERIC_DRAG_INPUT_SLIDER,
      this.globals.CONTROL_NUMERIC_INTEGER,
      this.globals.CONTROL_NUMERIC_SLIDER,
      this.globals.CONTROL_ROW_HEADER,
      this.globals.CONTROL_SIGNATURE,
      this.globals.CONTROL_SPACER,
      this.globals.CONTROL_TEXT_AREA,
      this.globals.CONTROL_TEXT_BOX,
      this.globals.CONTROL_TIME,
      this.globals.CONTROL_VITAL_SIGNS,
      this.globals.CONTROL_PHONE,
      this.globals.CONTROL_HIDDENINPUT,
      this.globals.CONTROL_MARKUP,
      this.globals.CONTROL_MACRO_NOTES_DROPDOWN,
      this.globals.CONTROL_IMAGE_LIST
    ];

    this.canUseValidValues = true;
    canValidValueControlTypes.forEach(validValue => {
      if (validValue.toLowerCase() === this.item.enumFormControlID.toLowerCase()) {
        this.canUseValidValues = false;
      }
    });

    const canUseDefaultValueTypes = [
      this.globals.CONTROL_ACTION_BUTTON,
      this.globals.CONTROL_GROUP_HEADING_WITH_SUMMARY,
      this.globals.CONTROL_HEADING,
      this.globals.CONTROL_LABEL,
      this.globals.CONTROL_LABEL_45,
      this.globals.CONTROL_ROW_HEADER,
      this.globals.CONTROL_SIGNATURE,
      this.globals.CONTROL_SPACER,
      this.globals.CONTROL_PHONE,
      this.globals.CONTROL_HIDDENINPUT,
      // this.globals.CONTROL_MARKUP,
    ];

    this.canUseDefaultValue = true;
    canUseDefaultValueTypes.forEach(validValue => {
      if (validValue.toLowerCase() === this.item.enumFormControlID.toLowerCase()) {
        this.canUseDefaultValue = false;
      }
    });

    const canUseAfterUpdateControlTypes = [
      this.globals.CONTROL_GROUP_HEADING_WITH_SUMMARY,
      this.globals.CONTROL_HEADING,
      this.globals.CONTROL_LABEL,
      this.globals.CONTROL_LABEL_45,
      this.globals.CONTROL_ROW_HEADER,
      this.globals.CONTROL_SPACER,
      this.globals.CONTROL_MARKUP,
    ];

    this.canUseAfterUpdateAction = true;
    canUseAfterUpdateControlTypes.forEach(validValue => {
      if (validValue.toLowerCase() === this.item.enumFormControlID.toLowerCase()) {
        this.canUseAfterUpdateAction = false;
      }
    });

    const canSelectDefaultValueFromValidValuesType = [
      this.globals.CONTROL_ACTION_BUTTON,
      this.globals.CONTROL_BLOOD_PRESSURE,
      this.globals.CONTROL_CURRENCY,
      this.globals.CONTROL_DATE,
      this.globals.CONTROL_DATE_TIME,
      this.globals.CONTROL_GROUP_HEADING_WITH_SUMMARY,
      this.globals.CONTROL_HEADING,
      this.globals.CONTROL_LABEL,
      this.globals.CONTROL_LABEL_45,
      this.globals.CONTROL_NUMERIC_DECIMAL,
      this.globals.CONTROL_NUMERIC_DRAG_INPUT_SLIDER,
      this.globals.CONTROL_NUMERIC_INTEGER,
      this.globals.CONTROL_NUMERIC_SLIDER,
      this.globals.CONTROL_ROW_HEADER,
      this.globals.CONTROL_SIGNATURE,
      this.globals.CONTROL_SPACER,
      this.globals.CONTROL_TEXT_AREA,
      this.globals.CONTROL_TEXT_BOX,
      this.globals.CONTROL_TIME,
      this.globals.CONTROL_VITAL_SIGNS,
      this.globals.CONTROL_PHONE,
      this.globals.CONTROL_HIDDENINPUT,
      this.globals.CONTROL_MARKUP,
      this.globals.CONTROL_BULLETPOINT,
    ];

    this.canSelectDefaultFromValidValue = true;
    canSelectDefaultValueFromValidValuesType.forEach(validValue => {
      if (validValue.toLowerCase() === this.item.enumFormControlID.toLowerCase()) {
        this.canSelectDefaultFromValidValue = false;
      }
    });

  }

  duplicate() {
    this.dialogRef.close({ delete: false, item: this.item, duplicate: true });
  }

  save() {
    this.dialogRef.close({ delete: false, item: this.item, duplicate: false });
  }

  cancel() {
    this.dialogRef.close({ delete: false, item: this.originalItem, duplicate: false });
  }

  delete() {
    this.dialogRef.close({ delete: true, duplicate: false });
  }


}
